import React, {useEffect, useState} from 'react';
import ApiDataBase from 'server'
import UseContext from "hooks/useContext";
import {InformationIcon} from "assets/icons";
import Tooltip from "components/tooltips/Tooltips";
import SectionWrapper, {FormField, inputClassName} from "../components/SectionWrapper";

const Salary = () => {
    const [smic, setSmic] = useState('')
    const [defaultValue, setDefaultValue] = useState(false)
    const {data, setData} = UseContext()

    const handleSelect = () => {
        setDefaultValue(!defaultValue)
    }

    useEffect(() => {
        ApiDataBase.getMinimumWage(
            (data) => {
                if(data?.hourly?.gross){
                    setSmic(data.hourly.gross)
                }
            },
            (err) => {
                console.log(err)
            }
        )
    }, [])

    useEffect(() => {
        if (defaultValue) {
            setData(prevData => ({
                ...prevData,
                salary: smic
            }))
        } else if (data.salary.length < 0) {
            setData(prevData => ({
                ...prevData,
                salary: ''
            }))
        }
    }, [defaultValue])

    return (
        <SectionWrapper 
            title="Rémunération de l'intérimaire" 
            description="Indiquez ci-dessous les informations permettant le calcul de la rémunération de vos intérimaires."
        >
            <FormField label="Taux horaire brut">
            <div className="relative">
                <input
                        name="salary"
                    value={data.salary}
                    onChange={(e) => setData(prevData => ({
                        ...prevData,
                        salary: e.target.value
                    }))}
                        className={`${inputClassName} pr-16`}
                    type="text"
                        placeholder="Ex: 12.50"
                />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <span className="ft-sm text-gray-500">€/heure</span>
                </div>
                <Tooltip
                    text={'La rémunération comprend le salaire ou traitement de base et tous les autres avantages et accessoires payés directement ou indirectement, en espèces ou en nature.'}
                    placement="bottom"
                >
                        <div className="absolute inset-y-0 right-16 z-20 flex items-center px-2 cursor-pointer">
                        <InformationIcon color={'#2CAFFF'} wh={15}/>
                    </div>
                </Tooltip>
            </div>
            </FormField>
            <div>
                <button
                    type="button"
                    onClick={handleSelect}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all ${
                        defaultValue 
                            ? 'border-yellow-500 bg-yellow-50 text-yellow-700' 
                            : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300'
                    }`}
                >
                    <div className={`w-4 h-4 rounded border flex items-center justify-center ${
                        defaultValue ? 'border-yellow-500 bg-yellow-500' : 'border-gray-300 bg-white'
                    }`}>
                        {defaultValue && (
                            <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        )}
                    </div>
                    <span className="ft-sm font-medium">SMIC horaire : {smic}€/h</span>
                </button>
            </div>
        </SectionWrapper>
    );
};

export default Salary;
